// src/data/exercises/L5_06.js

const accountOptions = [
  '現金', '建物', '租税公課', '当座預金', '仮払消費税'];

export const L5_06 = {
  title: '簿記　3級（第214-6回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
      parts: [
    { "type": "ruby", "text": "店舗", "ruby": "てんぽ" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "建物", "ruby": "たてもの" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "対", "ruby": "たい" },
    { "type": "text", "value": "する" },
    { "type": "ruby", "text": "固定資産税", "ruby": "こていしさんぜい" },
    { "type": "text", "value": "￥120,000を" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "納付", "ruby": "のうふ" },
    { "type": "text", "value": "した。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '租税公課', debitAmount: 120000, creditAccount: '現金', creditAmount: 120000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「現金で納付した。」納付＝支払う。\n' },
          { type: 'styled', value: '①現金で支払った＝現金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「固定資産税」＝租税公課　を使う借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
「現金で納付した。」納付＝支払う。
①現金で支払った＝現金の減少（マイナス）します。

②「固定資産税」＝租税公課を使います。

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
          parts: [
          { type: 'text', value: '「現金で納付した。」納付＝支払う。\n' },
          { type: 'styled', value: '①現金で支払った＝現金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「固定資産税」＝租税公課　を使う借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};